import type { SiteDomain } from '~/modules/appx_site_schema';
import { FeatureFlags } from '~/modules/feature_flags';
import { ENGLISH_LANGUAGE_CODE } from '~/modules/utilities/language_utils';

/**
 * Pure, cross-environment route boundary for the AgentExchange Skills landing page.
 *
 * Callers supply the current runtime flag so server routing, client routing, and sitemap
 * composition all use the same domain/locale rule without this helper reading global state.
 */
export function isSkillsLandingPageAvailable(
    domain: SiteDomain | undefined,
    language: string,
    skillsListingsEnabled: boolean,
): boolean {
    return skillsListingsEnabled && domain === 'agentexchange' && language === ENGLISH_LANGUAGE_CODE;
}

/**
 * The Skill/Plugin listing-detail UI is currently rolled out to AppExchange English.
 * Keep this pure boundary shared by the server and both client detail paths.
 */
export function isExternalAgentListingDetailAvailable(domain: SiteDomain | undefined, language: string): boolean {
    return FeatureFlags.FF_DISCOVERY_SKILLS_LISTINGS && domain === 'appexchange' && language === ENGLISH_LANGUAGE_CODE;
}
